'use client';

import theme, { blueGradientSxUp } from "@/theme/theme";
import { Stack, Typography, Box } from "@mui/material";

const AboutHero = () => {
    return (
        <Stack
            alignItems="center"
            justifyContent="center"
            width="100%"
            minHeight={{ xs: "35vh", lg: "45vh" }}
            paddingX={4}
            position="relative"
            overflow="hidden"
        >
            <Stack width={{ xs: "100%", lg: "60%" }} alignItems="center" justifyContent="center" gap={4} marginX="auto">
                <Typography 
                    variant="h1" 
                    component="h1" 
                    fontSize={{ xs: "1.85rem !important", lg: "3.75rem !important" }} 
                    className="chno" 
                    fontWeight={500} 
                    textAlign="center" 
                    textTransform="uppercase"
                >
                    <Box component="span" sx={blueGradientSxUp(theme)}>
                        About
                    </Box>
                    <br />
                    <Box component="span" sx={{ color: theme.palette.text.primary }}>
                        Mood Global Services
                    </Box>
                </Typography>
                <Typography
                    variant="h6"
                    component="h6"
                    fontWeight={300}
                    textAlign="center"
                    fontSize={{ xs: "1rem !important", lg: "1.125rem !important" }}
                    color="text.secondary"
                    sx={{ maxWidth: '800px', lineHeight: 1.6 }}
                >
                    We are your bespoke nerdy dev studio. We combine deep technical expertise with a passion for building scalable, future-proof digital products. Build here, grow anywhere.
                </Typography>
            </Stack>
        </Stack>
    );
};

export default AboutHero;